const main_slider = document.querySelector('.product__media-list');
const thumbnail_slider = document.querySelector('.thumbnail-list');
const isMobile =  window.matchMedia('(max-width: 749px)').matches;
if(isMobile){
    var flkty = new Flickity( main_slider, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
      adaptiveHeight: true,
        arrowShape: "M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"
      });
}else{
    var flkty = new Flickity( main_slider, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
      adaptiveHeight: true,
        arrowShape: "M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"
      });
      if(thumbnail_slider){
        var flkty1 = new Flickity( thumbnail_slider, {
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          asNavFor: main_slider,
  
        });
      }
}


